import { KontentBrandColor } from "../types/index";

export function getColor(kontentColor: { value: KontentBrandColor[] }) {
  if (kontentColor?.value[0]?.elements?.hex_value?.value) {
    return "#" + kontentColor?.value[0]?.elements?.hex_value?.value;
  }

  return undefined;
}

export const brandColors = {
  green: "#205C40",
  white: "#ffffff",
  cream: "#f6f1e5",
  black: "#11110f",
  beige: "#eee9dd",
  lightgreen: "#00c18a",
  teal: "#6eaba5",
  gray: "#70706f",
};
